/**
 * Auto generated build file to add global access to
 * provided methods
 */

import PermissionsController from './controllers/permissions-controller';

Stimulus.register('permissions', PermissionsController);
